import React, { useEffect, useMemo, useRef, useState, useCallback, Suspense } from "react";
import Header from "../Header";
import {
  clearAcceptedOrderFromNotifications,
  getCurrentVersions,
  isAssignedLicenceSEP,
  isCloseBalanceType,
  isMobileView,
  notificationTypes,
  tryJsonParse,
  isSupportLogin
} from "../../helper/commonHelpers";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Button, Modal } from "@mui/material";
import Toast from "components/Toast";
import { paymentSuccessPopup, updateInfoModal, updateToastInfo } from "redux-store/slices/CheckoutSlice";
import { PostSalePopup } from "components/PostSalePopup";
import { useDispatch } from "react-redux";
import { registerFCMToken, setBusinessData } from "redux-store/slices/RegisterSlice";
import { isEmpty, set } from "lodash";
import { getSendData, stopDesktopNotification } from "helper/myOrderHelpers";
import { Outlet } from "react-router-dom";

import { HomeLayoutContext } from "contextAPI/homeLayoutContext";
import {
  orderLevelError,
  updateNotificationValue,
  updateMasterConnectedStatus,
  toggleKeyboardShortcutsModal,
  isDownloadCompleted
} from "redux-store/slices/GlobalSlice";
import WhatsNewReleaseModal from "@rista/ui/components/WhatsNewSection";

import { getNewChatNotificationDetails, getNewOrderData, getOverviewOrderData } from "redux-store/slices/MyOrderSlice";
import { refreshOrdersList } from "@rista/core/myOrders/refresh";
import { pollForTickets } from "utils/polling";
import { handleGetCallback, handleLocalServerCallBack } from "utils/OfflineUtil";
import { CONTROL_CAPITALK, CONTROL_ENTER, CONTROL_SMALLK, ESC, ESCAPE } from "utils/keyboardKeysConstants";
import {
  ATOKEN,
  AUTO_REMOVE,
  CASH_REGISTER,
  CASH_REGISTER_MODAL_TYPES,
  CASH_SETTLEMENT_ERROR_CODES,
  CASH_SETTLEMENT_STATUS_TYPES,
  DEVICEIDENTIFIER,
  LOCALSTORAGE_KEYS,
  OTHERS,
  REDUX_PERSIST_STATE,
} from "utils/constants";
import { closeCashRegisterModal, getCashSettlementDetails, updateErrorModalConfig } from "redux-store/slices/CashRegisterSlice";
import { getLatestVersion, logoutUser } from "redux-store/slices/LoginSlice";
import { fetchCatalogCompleteData } from "helper/catalogueHelpers";
import { featureRestrictions } from "helper/featureRestrictionHelper";
import { removeLocalStorage } from "../../utils";
import { resetLogout, showLogoutToast } from "../../redux-store/slices/LoginSlice";
import { clearLocalStorage, getLocalStorage, setLocalStorage } from "../../utils";
import { handlePrintData } from "helper/printHelper";
import { handleOfflineError } from "helper/OfflineHelper";
import { useIsLoggedinStatus } from "hooks/useIsLoggedinStatus";
import { getAllTablesFn, getTableReservationDataFn, isOffline, switchUserFn } from "facade/ServiceFacade";
import { setNetworkStatus } from "redux-store/slices/LocalServerSlice";
import { getPOSSettingsData, getPOSSettingsDataSuccess } from "redux-store/slices/catalogueSlice";
import { isMaster, isMasterOffline, isSlave } from "helper/localServer";
import { ROUTE_CONSTANTS_MAP } from "utils/routeConstants";
import { savePosSettings } from "redux-store/slices/PosSettingsSlice";
import { resetCurrentShortcut } from "redux-store/slices/KeyBoardShortcuts";
import { acceptOnlineOrder } from "helper/saleHelpers";
import { closeNotifications, getAllNewOnlineOrdersSuccess, notificationCurrentStatus, showStopNotificationNudge, storeCurrOtherNotifications, toggleOnlineNotificationsModal } from "redux-store/slices/NotificationsSlice";
import { unReadNotificationsCount } from "helper/notificationHelpers";
import { getUpdatedNotificationData } from "./getUpdateNotificationData";
import { isAndroid, isElectron, exec } from "utils/nativeHooks";
import { playNotificationRinger } from "helper/notificationHelper";
import { setSyncData } from "redux-store/slices/CustomerSlice";

import { fetchCommonData } from "redux-store/slices/common";
import { METHODS, NOTIFICATION_TITLES, NW_APP_EVENT_ACTIONS, NW_APP_EVENT_KEYS, NW_APP_LATEST_STABLE_VERSION } from "data/constants";
import { ENDPOINT } from "config/endpoints";
import { ToastNotifySuccess } from "commonComponents/ToastNotify";
import { getVersionNumber } from "helper/versionHelper";
import CustomLoyaltyContextProvider from "components/Loyalty/RistaLoyalty/loyalty-modal-context";
import { LicenceExpiryState } from "redux-store/slices/LicenceExpirySlice";
import { useEvent } from "hooks/useEvent";
import { setupNotificationsListener } from "redux-store/middleware/notificationsListener";
import { useCheckForChatSupport, useEnableNotificationPolling, useNotAdmin, useIsPostSaleCommunicationEnabled } from "hooks/commonHooks";
import { lazyWithHandler } from "commonComponents/LazyLoadWrapper";
import { useHealthStatusCheck } from "hooks/useHealthStatusCheck";
import useWhatsNewLogic from "@rista/ui/components/WhatsNewSection/hooks";


// Lazy load components
const OnlineOrderNotification = lazyWithHandler(() => import("commonComponents/OnlineOrderNotification"));
const NotificationsModalMB = lazyWithHandler(() => import("components/NotificationsModalMB"));
const BranchToggleInfoModal = lazyWithHandler(() => import("commonComponents/InfoModal"));
const DisplayKeyboardShortcuts = lazyWithHandler(() => import("components/DisplayKeyboardShortcuts"));
const LocalServerStatusPopup = lazyWithHandler(() => import("./localServerStatusPopup"));
const CashRegisterModal = lazyWithHandler(() => import("components/CashRegister/cash-register-modal"));
const MultiErrorToast = lazyWithHandler(() => import("components/MultiErrorToast"));
const OpenBranchModal = lazyWithHandler(() => import("commonComponents/OpenBranchModal"));
const NotificationStopNudge = lazyWithHandler(() => import("commonComponents/NotificationStopModal"));
const ChatSupportNotification = lazyWithHandler(() => import("commonComponents/ChatSupport/chatSupportNotification"));
const ChatSupport = lazyWithHandler(() => import("commonComponents/ChatSupport"));
const LicenceExpiryStatus = lazyWithHandler(() => import("commonComponents/LicenceExpiryStatus"));
const SaleSyncModal = lazyWithHandler(() => import("components/SaleSyncModal"));
const CheckoutContainer = lazyWithHandler(() => import("Containers/CheckoutContainer"));
const NewOrderContainer = lazyWithHandler(() => import("Containers/NewOrder/index"));

interface Props {
  children: any;
}

const style = {
  maxWidth: 500,
  width: "100%",
  bgcolor: "#fff",
  borderRadius: "10px",
  boxShadow: 24,
  outline: "none",
  p: 4,
};

const HomeLayout: React.FC<Props> = (props) => {
  const [notificationsToShow, setNotificationsToShow] = useState<any>([]),
    [showNotifications, setShowNotifications] = useState<any>({ show: false, openForAll: false }),
    navigateTo = useNavigate(),
    { toastInfo, infoModalState: infoModal, checkoutModalState, paymentSuccess: showPostSalePopup } = useSelector((state: any) => state.checkoutModalStore || {}),
    showMobileNotifications = useSelector((state: any) => state.notificationsStore?.showOnlineNotification),
    orderLevelErrors = useSelector((state: any) => state.globalStore?.orderLevelErrors),
    loginResponseData = useSelector((state: any) => state.loginStore?.loginResponse),
    showKeyboardShortcutsModal = useSelector((state: any) => state.globalStore?.showKeyboardShortcuts),
    newOnlineOrders = useSelector((state: any) => state.notificationsStore?.newOnlineOrders),
    currOtherNotifications = useSelector((state: any) => state.notificationsStore?.currOtherNotifications),
    isStopNotificationNudge = useSelector((state: any) => state.notificationsStore?.showStopNotificationNudge),
    isNotificationAlreadyStop = useSelector((state: any) => state.notificationsStore?.isNotificationStop),
    posPreferences = useSelector((state: any) =>
      state.catalogStore?.posSettings
    ),
    branchData = useSelector((state: any) => state.OutletStatusStore?.branchData),
    infoModalData = useSelector((state: any) => state.OutletStatusStore?.toggleBranchInfoData),
    dispatch = useDispatch(),
    isMasterConnected = useSelector((state: any) => state.globalStore.isMasterConnected),
    syncOrderData = useSelector((state: any) => state.customerStore?.setSyncData);
  const allTables = useSelector((state: any) => state.tableViewStore?.allTables || []);
  const saleItems = useSelector((state: any) => state.saleDataStore?.saleData?.saleItems || []);
  const defaultPrinterDetails = useSelector((state: any) => state.printerStore?.defaultPrinter);
  const [startCallsCount, setStartCallsCount] = useState(0);
  const currentPlatform = getLocalStorage(LOCALSTORAGE_KEYS.nwPlatform) || '';
  const appVersions = getCurrentVersions();
  const currentVersion = appVersions.nwAppVersion;
  const [showChatSupportIcon, setShowChatSupportIcon] = useState(true),
    [isChatSupportOpen, setIsChatSupportOpen] = useState<boolean>(false),
    [listOfNewChatSupport, setListOfNewChatSupport] = useState<string[]>([]),
    timeoutRef = useRef<any>('');

  const currentTab = window?.location?.pathname;
  const { pathname } = useLocation();
  const isNewOrderRoute = pathname === ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE;


  const allOtherNotifications = useSelector(
    (state: any) => state.notificationsStore?.allOtherNotifications?.results
  );
  const { showBanner }: LicenceExpiryState = useSelector((state: any) => state.LicenceExpirySlice);
  const [openMobileNotification, setOpenMobileNotification] = useState<boolean>(false);

  const [isMenuOpen, setisMenuOpen] = useState<boolean>(false);
  const [openItemStockStatus, setOpenItemStockStatus] =
    useState<boolean>(false);
  const unReadNotifications = unReadNotificationsCount(allOtherNotifications);
  const isDeviceOffline = useSelector((state: any) => state.businessStore?.isOffline);
  let showLsNotReachablePopup =
    isSlave() &&
    !isMasterConnected &&
    [ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE, ROUTE_CONSTANTS_MAP.MY_ORDER_ROUTE, ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE].includes(window?.location?.pathname);

  const [notificationNumber, setNotificationNumber] = useState<number>(0);
  const {
    showCashRegisterModal,
    cashRegisterModalType,
    cashSettlementDetails,
    currentDeviceInfo,
    openDeviceInfo,
    logoutResponse,
    branchSwitchData,
    switchUserData,
    users,
  } = useSelector((state: any) => ({
    showCashRegisterModal: state.cashRegisterStore.showCashRegisterModal,
    cashRegisterModalType: state.cashRegisterStore.cashRegisterModalType,
    cashSettlementDetails: state.cashRegisterStore.cashSettlementDetails,
    currentDeviceInfo: state.businessStore?.businessData?.deviceInfo,
    openDeviceInfo: state.cashRegisterStore?.cashSettlementDetails?.openInfo?.deviceInfo,
    logoutResponse: state.loginStore?.logoutResponse,
    branchSwitchData: state.cashRegisterStore.branchSwitchData,
    switchUserData: state.cashRegisterStore.switchUserData,
    users: state?.registerStore?.users,
  }));
  const businessData = useSelector((state: any) => state.businessStore?.businessData);
  const userData = useSelector((state: any) => state.businessStore?.userData);
  const hasChatSupport = useCheckForChatSupport();
  const { isEnabled: isPostSaleCommunicationEnabled } = useIsPostSaleCommunicationEnabled();
  let timerId10: any = null; // timer with interval 10 sec
  let timerId20: any = null; // timer with interval 20 sec
  const isTypeCloseBalance = useMemo(() => {
    return isCloseBalanceType()
  }, [cashRegisterModalType]);

  const shortcutBtn = useSelector((state: any) => state.keyboardShortcutStore?.currentShortcutPressed);
  const isLoggedin = useIsLoggedinStatus();

  const enableNotificationPolling = useEnableNotificationPolling()

  const isUserNotAdmin = useNotAdmin();

  const { isSaleSyncing, closeSaleSyncModal } = useHealthStatusCheck();

  const { showLaunchWhatsNewModal, setShowLaunchWhatsNewModal,  releaseHashKey} = useWhatsNewLogic();
  
  useEffect(() => {
    if (showPostSalePopup && !isPostSaleCommunicationEnabled) {
      dispatch(paymentSuccessPopup(false));
    }
  }, [showPostSalePopup, isPostSaleCommunicationEnabled, dispatch]);

  useEffect(() => {
    const notificationsPolling = getLocalStorage(LOCALSTORAGE_KEYS.notificationsPolling) === "true";
    if (isUserNotAdmin && enableNotificationPolling && !notificationsPolling) {
      (window as any).__toggleNotificationsPolling?.(true);
    }

    if (isUserNotAdmin && enableNotificationPolling && notificationsPolling) {
      // Enable listener on mount
      const unsubscribe = setupNotificationsListener();

      // Disable listener on unmount
      return () => unsubscribe();
    }

  }, [isUserNotAdmin, enableNotificationPolling])

  useEffect(() => {
    let timeoutId: string | number | NodeJS.Timeout;
    if (listOfNewChatSupport?.length) {
      timeoutId = setTimeout(() => {
        setListOfNewChatSupport((prev: string[]) => {
          if (prev?.length) {
            const updatedState = prev?.slice(1);
            return updatedState;
          }
          return []
        });
      }, 10000)
    }
    return () => clearTimeout(timeoutId);
  }, [listOfNewChatSupport])

  useEffect(() => {
    const versionNumber = getVersionNumber();
    const isSuitableVersion = !isNaN(versionNumber) && versionNumber <= NW_APP_LATEST_STABLE_VERSION; //equality check is added for electron update check
    if (
      !isAndroid() &&
      currentVersion.length &&
      currentPlatform.length &&
      getLocalStorage(LOCALSTORAGE_KEYS.appUpdateAvailable)
      && isSuitableVersion
    ) {
      dispatch(getLatestVersion({ currentPlatform, currentVersion }));
    }
  }, [currentVersion, currentPlatform]);

  useEffect(() => {
    if (userData?.assignedLicence && featureRestrictions(CASH_REGISTER) && isAssignedLicenceSEP()) {
      dispatch(
        getCashSettlementDetails({
          modalType: CASH_REGISTER_MODAL_TYPES.opening_balance,
        })
      );
    }
  }, [userData?.assignedLicence, userData?.allowedFeatures?.length]);

  useEffect(() => {
    if (allTables?.length && (currentTab === ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE || currentTab === ROUTE_CONSTANTS_MAP.RESERVATIONS_ROUTE)) {
      getTableReservationDataFn({skipGlobalLoader: true});
      const intervalId = setInterval(() => {
        getTableReservationDataFn({skipGlobalLoader: true});
      }, 60 * 1000);
      return () => clearInterval(intervalId);
    }
  }, [allTables?.length, currentTab]);

  useEffect(() => {
    if (
      cashSettlementDetails?.status === CASH_SETTLEMENT_STATUS_TYPES.open &&
      openDeviceInfo?.label &&
      currentDeviceInfo?.label &&
      currentDeviceInfo?.label !== openDeviceInfo?.label &&
      featureRestrictions(CASH_REGISTER)
    ) {
      let deviceList: any[] = cashSettlementDetails?.deviceList || [];
      const openDeviceData = deviceList.find((device: any) => device?.label === openDeviceInfo?.label);
      dispatch(
        updateErrorModalConfig({
          show: true,
          code: CASH_SETTLEMENT_ERROR_CODES.REST_SETTLEMENT_NOT_OPEN_ON_DEVICE,
          message: openDeviceData || openDeviceInfo,
        })
      );
      callLogoutApi();
    } else {
      dispatch(updateErrorModalConfig({ show: false }));
    }
  }, [openDeviceInfo, currentDeviceInfo]);

  const newOrderNotificationHandler = (message: any) => {
    if (!message?.event) return;
    if (typeof message?.event === 'string') {
      try {
        message = { ...message, event: JSON.parse(message?.event) }
      } catch (err) {
        console.log("notif error: ", err)
      }
    }
    handleIncomingNotifications(newOnlineOrders, message, "orders");
    dispatch(notificationCurrentStatus(false));
    dispatch(showStopNotificationNudge(false));
    updateNotification();
  }

  const pushNotificationHandlers: Record<string, (message: any) => void> = {
    [NOTIFICATION_TITLES.TABLE_ORDER]: (_message) => {
      getAllTablesFn({skipGlobalLoader: true});
    },
    [NOTIFICATION_TITLES.ONLINE_ORDER]: newOrderNotificationHandler,
    [NOTIFICATION_TITLES.INSTORE_ORDER]: newOrderNotificationHandler,
  };

  const handleChromePushNotification = (message: any) => {
    const titleHandler = pushNotificationHandlers[message?.title];
    const defaultHandler = notificationTypes(message?.title) ? (msg: any) => {
      dispatch(storeCurrOtherNotifications(msg));
      dispatch(notificationCurrentStatus(true));
      handleIncomingNotifications(currOtherNotifications, msg, "others");
      if (unReadNotifications < 20) updateNotification();
    } : undefined;
    (titleHandler ?? defaultHandler)?.(message);
    if (window?.location?.pathname?.includes("my-orders")) {
      console.log("firing api!!");
      setTimeout(() => {
        // my-orders v2 owns its reads (D13/D14): on a v2 terminal this refresh has to reach
        // v2's store, which no longer mirrors v1's action types
        let obj: any = getSendData("overview", "delivery");
        if (!refreshOrdersList("overview", "delivery")) dispatch(getOverviewOrderData({ data: obj }));
      }, 300);
    }
    pollForTickets();
    // callWorker()
    console.log("Notification received: ", message);
  };

  const nwMessageHandlers: Record<string, (message: any, action?: string) => void> = {
    [`${NW_APP_EVENT_KEYS.push}:${NW_APP_EVENT_ACTIONS.push.registration}`]: (message) => {
      console.log("Push registration success");
      dispatch(registerFCMToken(message.registrationId));
    },
    [`${NW_APP_EVENT_KEYS.push}:${NW_APP_EVENT_ACTIONS.push.notification}`]: (message) => handleChromePushNotification(message),
    [`${NW_APP_EVENT_KEYS.printer}:${NW_APP_EVENT_ACTIONS.printer.discoverLocalDevices}`]: (message) => {
      if (!isEmpty(message.error)) {
        console.log(message.error);
      } else if (!isEmpty(message.success)) {
        // Fire action with success data
      }
    },
    [`${NW_APP_EVENT_KEYS.printer}:${NW_APP_EVENT_ACTIONS.printer.discoverBluetoothDevices}`]: (message) => {
      if (!isEmpty(message.error)) {
        console.log(message.error);
      }
    },
    [`${NW_APP_EVENT_KEYS.printer}:${NW_APP_EVENT_ACTIONS.printer.discoverUSBDevices}`]: (message) => {
      if (!isEmpty(message.error)) {
        console.log(message.error);
      } else if (!isEmpty(message.success)) {
        // Fire action with success data
      }
    },
    [`${NW_APP_EVENT_KEYS.printer}:${NW_APP_EVENT_ACTIONS.printer.requestUSBPermission}`]: (message) => {
      if (!isEmpty(message.error)) {
        console.log("USB Permission Denied");
      } else if (!isEmpty(message.success)) {
        console.log("USB Permission Granted");
      }
    },
    [`${NW_APP_EVENT_KEYS.printer}:${NW_APP_EVENT_ACTIONS.printer.print}`]: (message) => {
      if (!isEmpty(message.error)) {
        console.log(message.error);
      } else if (!isEmpty(message.success)) {
        console.log("Printed Successfully");
      }
    },
    [`${NW_APP_EVENT_KEYS.ristadb}:`]: (message) => {
      handleGetCallback(message);
    },
    [`${NW_APP_EVENT_KEYS.networkinfo}:`]: (_message: any, action?: string) => {
      dispatch(setNetworkStatus(action));
    },
    [`${NW_APP_EVENT_KEYS.server}:${NW_APP_EVENT_ACTIONS.server.error}`]: (_message) => {
      dispatch(updateMasterConnectedStatus(false));
      // ToastNotifyError(pos_errormap["ERR_SERVER_IO"]);
    },
    [`${NW_APP_EVENT_KEYS.server}:${NW_APP_EVENT_ACTIONS.server.start}`]: (message) => {
      setStartCallsCount((cnt) => cnt + 1);
      console.log("inside react ---- received server start event from nw---message=", message);
      updateLsIpAddr(message?.success?.address);
      handleLocalServerCallBack(message);
      dispatch(updateMasterConnectedStatus(true));
    },
    [`${NW_APP_EVENT_KEYS.server}:${NW_APP_EVENT_ACTIONS.server.serverStatus}`]: (message) => {
      if (!message?.isRunning) {
        serverStartEvent(posPreferences?.localServer?.address);
      } else {
        dispatch(updateMasterConnectedStatus(true));
      }
      console.log("-----inside React----React--=action=serverStatus =======message=====", message);
      // handleLocalServerCallBack(message);
    },
    [`${NW_APP_EVENT_KEYS.server}:`]: (message) => {
      dispatch(updateMasterConnectedStatus(true));
      handleLocalServerCallBack(message);
    },
    [`${NW_APP_EVENT_KEYS.appUpdateCodeAvailable}:`]: (message) => {
      const isCodeAvailable = message ? true : false;
      setLocalStorage(LOCALSTORAGE_KEYS.appUpdateAvailable, isCodeAvailable || false);
    },
    // [`update.download:`]: (message) => { dispatch(isDownloadCompleted(message)); },
  };

  const receiveDataFromNW = (e: any) => {
    const { key, action = "", message } = e.detail;
    const handlerKey = `${key}:${action}`;
    const handler = nwMessageHandlers[handlerKey] ?? nwMessageHandlers[`${key}:`];
    handler?.(message, action);
  };

  const stableReceiveDataFromNW = useEvent(receiveDataFromNW);

  const receiveDataFromNativeApp = (event: any) => {
    if (event?.data?.name === 'newMessageReceived') {
      const orderId = event?.data?.payload?.orderId;
      setListOfNewChatSupport(prev => [...prev, orderId]);
      dispatch(getNewChatNotificationDetails(orderId))
    }
    if (typeof event?.data === 'string' && event.data.includes('webpackHot')) //ignore webpack event
      return; // fix webpack reload error in testing env.
    const response = event?.data && typeof event?.data === "string" && tryJsonParse(event?.data);
    let message = response?.data?.data;
    if (event.data?.detail?.message?.ACTION === "LOGOUT_USER") {
      callLogoutApi();
    } else if (event.data?.detail?.message?.ACTION === "BRANCH_SWITCH") {
      const businessStoreData = JSON.stringify({ businessData });
      let deviceIdentifier = getLocalStorage(DEVICEIDENTIFIER);
      callLogoutApi();
      clearLocalStorage();
      const persistedRoot = JSON.stringify({
        businessStore: businessStoreData,
        _persist: JSON.stringify({ version: 1, rehydrated: true }),
      });
      setLocalStorage(REDUX_PERSIST_STATE, persistedRoot);
      setLocalStorage(DEVICEIDENTIFIER, deviceIdentifier);
    } else if (event.data?.detail?.message?.ACTION === "WIDGET_PRINT") {
      let printContent = event.data?.detail?.message?.dataToSend?.printContent;
      let printerInfo = event.data?.detail?.message?.dataToSend?.printer||defaultPrinterDetails;
      if (printContent) {
        handlePrintData(printContent, printerInfo);
      }
    } else if (event.data?.detail?.message?.ACTION === "WIDGET_OPEN_EXTERNAL_LINK") {
      let link = event.data?.detail?.message?.dataToSend?.link;

      if (!link) {
        return;
      }

      if ((window as any)?.nw?.Shell) {
        (window as any).nw.Shell.openExternal(link);
      } else {
        window.open(link, "_system");
      }
    }

    if (response?.eventName === "") {
      return;
    } else if (response?.eventName === "pushNotification" && response?.data?.data?.title === "New Online Order") {
      if (window?.location?.pathname?.includes("my-orders")) {
        setTimeout(() => {
          let obj: any = getSendData("new", "delivery");
          if (!refreshOrdersList("new", "delivery")) dispatch(getNewOrderData({ data: obj, hideLoader: true }));
        }, 300);
      }
      updateNotification();
      if (message?.event) {
        message = { ...message, event: JSON.parse(message?.event) }
        handleIncomingNotifications(newOnlineOrders, message, "orders");
        updateNotification();
      }
    } else if (notificationTypes(message?.title)) {
      dispatch(storeCurrOtherNotifications(message));
      handleIncomingNotifications(currOtherNotifications, message, "others");
      if (unReadNotifications < 20) { updateNotification(); }
    }
  };
  const stableReceiveDataFromNativeApp = useEvent(receiveDataFromNativeApp);

  useEffect(() => {
    // ── Electron host: typed IPC listeners ──────────────────────────────────────
    if (isElectron()) {
      const pushNotifRef = window.electronAPI!.push.onNotification((message: any) => {
        playNotificationRinger(message);

        // Mirror the _platform_message handler below for push:notification
        if (!!message?.event && message.event !== "TABLE_ORDER_UPDATE") {
          if (typeof message?.event === 'string') {
            try { message = { ...message, event: JSON.parse(message.event) }; } catch (_) {}
          }
          handleIncomingNotifications(newOnlineOrders, message, "orders");
          dispatch(notificationCurrentStatus(false));
          dispatch(showStopNotificationNudge(false));
          updateNotification();
        } else if (notificationTypes(message?.title)) {
          dispatch(storeCurrOtherNotifications(message));
          dispatch(notificationCurrentStatus(true));
          handleIncomingNotifications(currOtherNotifications, message, "others");
          if (unReadNotifications < 20) updateNotification();
        }
        pollForTickets();
      });

      const pushRegRef = window.electronAPI!.push.onRegistration((data: any) => {
        console.log("Electron push registration success");
        dispatch(registerFCMToken(data.registrationId));
      });

      const serverNetRef = window.electronAPI!.server.onNetworkRequest((data: any) => {
        handleLocalServerCallBack(data);
      });

      const serverErrRef = window.electronAPI!.server.onError((err) => {
        if(err?.message === "timeout") {
          dispatch(updateMasterConnectedStatus(false));
        }
        console.log("localServer: error", err)
      });

      return () => {
        window.electronAPI!.push.off('push:notification', pushNotifRef);
        window.electronAPI!.push.off('push:registration', pushRegRef);
        window.electronAPI!.server.off('server:networkrequest', serverNetRef);
        window.electronAPI!.server.off('server:error', serverErrRef);
      };
    }

    // ── Non-Electron hosts: postMessage / _platform_message (unchanged) ─────────
    window.addEventListener("message", stableReceiveDataFromNativeApp);
    window.postMessage(
      {
        detail: {
          test: "Access page loaded",
        },
      },
      "*"
    );
    // parent.dispatchEvent(new CustomEvent('_app_message', {
    //   detail: {
    //     text: "Hi from POS"
    //   }
    // }));
    document.addEventListener("message", stableReceiveDataFromNativeApp);
    // ✅ Safe cross-origin error catch
    try {
      parent.addEventListener("_platform_message", stableReceiveDataFromNW);
    } catch (error: any) {
      console.warn('[Cross-Origin Warning]', error.message);
      if (error && error.toString().indexOf("parent") && isOffline()) {
        handleOfflineError("OFFLINE_DB_NOT_REACHABLE");
      }
    }
    return () => {
      document.removeEventListener("message", stableReceiveDataFromNativeApp);
      window.removeEventListener("message", stableReceiveDataFromNativeApp);
      // ✅ Safe cross-origin error catch
      try {
        parent.removeEventListener("_platform_message", stableReceiveDataFromNW);
      } catch (error) {
        console.warn('[Cross-Origin Warning]', error);
      }
    };
  }, [stableReceiveDataFromNW, stableReceiveDataFromNativeApp]);

  useEffect(() => {
    if (businessData?.branchId) {
      if (isSlave() || getLocalStorage(LOCALSTORAGE_KEYS.aToken)) {
        isSlave() && isMasterOffline((res: any) => { });

        timerId10 = setInterval(() => {
          getLocalStorage(LOCALSTORAGE_KEYS.aToken) &&
            pollForTickets();
          isSlave() && isMasterOffline((res: any) => { });
        }, 10 * 1000);
      }

      if (isMaster()) {
        timerId20 = setInterval(() => {
          if (!isMaster()) return;
          if (isElectron()) {
            // server.status() returns Promise<{isRunning}> — handle inline
            // instead of relying on the legacy synthetic _platform_message.
            window.electronAPI!.server.status().then((result: any) => {
              if (!result?.isRunning) {
                serverStartEvent(posPreferences?.localServer?.address);
              } else {
                dispatch(updateMasterConnectedStatus(true));
              }
            });
          } else {
            exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.serverStatus, [posPreferences?.localServer?.address]);
          }
        }, 20 * 1000);
      } else {
        dispatch(updateMasterConnectedStatus(true));
      }
    }

    return () => {
      clearInterval(timerId10);
      clearInterval(timerId20);
      timerId10 = null;
      timerId20 = null;
    };
  }, [businessData?.branchId, posPreferences?.localServer?.address]);

  const TAB_ROUTES = [ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE, ROUTE_CONSTANTS_MAP.MY_ORDER_ROUTE, ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE];
  useEffect(() => {
    if (TAB_ROUTES.includes(pathname) && businessData?.branchId && getLocalStorage(LOCALSTORAGE_KEYS.aToken)) {
      dispatch(getPOSSettingsData({ branchId: businessData.branchId, skipGlobalLoader: true }));
      isSlave() && isMasterOffline((res: any) => { });
    }
  }, [pathname]);

  useEffect(() => {
    if (!isLoggedin) {
      navigateTo(ROUTE_CONSTANTS_MAP.LOGIN_ROUTE);
    }
  }, [isLoggedin]);

  // Push current app state to the Electron main process so the HTTP server
  // can answer kiosk IS_OFFLINE / DEVICE_INFO / PRINT requests correctly,
  // including after an app restart while logged in.
  useEffect(() => {
    if (!isElectron()) return;
    if (currentDeviceInfo) {
      window.electronAPI!.server.setDeviceInfo(currentDeviceInfo);
    }
    if (defaultPrinterDetails) {
      window.electronAPI!.server.setPrinterConfig({ defaultPrinter: defaultPrinterDetails });
    }
  }, [currentDeviceInfo, defaultPrinterDetails]);

  // Keep the Electron main-process offline flag in sync with the Redux store
  useEffect(() => {
    if (!isElectron()) return;
    window.electronAPI!.server.setOffline(isDeviceOffline);
  }, [isDeviceOffline]);

  useEffect(() => {
    if (infoModal?.isOpen) {
      if (shortcutBtn === ESC || shortcutBtn === ESCAPE || shortcutBtn === CONTROL_ENTER) {
        handleInfoModalClose();
        dispatch(resetCurrentShortcut());
      }
    }
    if (shortcutBtn === CONTROL_SMALLK || shortcutBtn === CONTROL_CAPITALK) {
      dispatch(toggleKeyboardShortcutsModal({ show: !showKeyboardShortcutsModal }));
      dispatch(resetCurrentShortcut());
    }
  }, [shortcutBtn]);

  useEffect(() => {
    if (logoutResponse.status === "success") {
      removeLocalStorage("ATOKEN");
      dispatch(resetLogout());
      dispatch(showLogoutToast());
      navigateTo(ROUTE_CONSTANTS_MAP.LOGIN_ROUTE);
    }
  }, [logoutResponse]);

  useEffect(() => {
    if (
      posPreferences?.localServer?.deviceIdentifier === getLocalStorage(DEVICEIDENTIFIER) &&
      !!posPreferences?.localServer?.address
    ) {
      serverStartEvent(posPreferences.localServer.address);
    } else if (isMaster()) {
      serverStopEvent();
    }
  }, [posPreferences]);

  useEffect(() => {
    if(isElectron()) {
      window.electronAPI!.checkForUpdates();
    } else {
      exec(NW_APP_EVENT_KEYS.appUpdateCodeAvailable, "", "");
    }
    const handleUnload = () => {
      if (getLocalStorage(LOCALSTORAGE_KEYS.isShowOfflineModeToggle)) {
        removeLocalStorage(LOCALSTORAGE_KEYS.aToken);
      }
    };
    window.addEventListener("beforeunload", handleUnload);

    return () => window.removeEventListener("beforeunload", handleUnload);
  }, []);

  const [newOrderVisited, setNewOrderVisited] = useState(false);
  useEffect(() => {
    if (isNewOrderRoute && !newOrderVisited) setNewOrderVisited(true);
  }, [isNewOrderRoute]);

  useEffect(() => {
    console.log("Registering for push notifications");
    const configForWebsocketConnection = {
      deviceIdentifier: getLocalStorage(LOCALSTORAGE_KEYS.deviceIdentifier),
      atoken: getLocalStorage(LOCALSTORAGE_KEYS.aToken),
      webSocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
      logUrl: process.env.REACT_APP_RISTA_BASE_API_URL + 'log',
    }
    if (isElectron()) {
      window.electronAPI!.push.register(configForWebsocketConnection);
    } else {
      exec(NW_APP_EVENT_KEYS.push, NW_APP_EVENT_ACTIONS.push.register, [configForWebsocketConnection]);
    }
  }, [loginResponseData, pathname]);

  const updateNotification = () => {
    setNotificationNumber((notificationNumber) => notificationNumber + 1);
    dispatch(updateNotificationValue(notificationNumber + 1));
  };

  const callLogoutApi = () => {
    let tokenId = getLocalStorage(ATOKEN);
    dispatch(logoutUser(tokenId));
  };

  function updateBranchCallback(res: any) {
    if (!res.code) {
      callLogoutApi();
      ToastNotifySuccess(`Branch has been successfully changed to ${branchSwitchData.branchName}`)
      //TODO: reset pinned channels?
      dispatch(
        setBusinessData({
          ...users.users,
          branchName: branchSwitchData.branchName,
          businessName: branchSwitchData.businessName,
        })
      );
    }
  }

  function handleSwitchBranch() {
    let payload = {
      branchId: branchSwitchData.branchId,
    };
    dispatch(
      fetchCommonData({
        method: METHODS.POST,
        body: payload,
        url: ENDPOINT.COMMON.updateBranch,
        callback: updateBranchCallback,
        errorCallback: true,
      })
    );
  }

  function handleSwitchUser() {
    switchUserFn(switchUserData);
  }

  function handleCloseNotification(type = 'other', isManual = false) {
    if (type === 'other' || (type === AUTO_REMOVE)) {
      setShowNotifications({ show: false });
      if (timeoutRef.current) {
        dispatch(showStopNotificationNudge(true));
        clearTimeout(timeoutRef.current);
        timeoutRef.current = '';
      }
    }
    dispatch(closeNotifications());
    setNotificationsToShow([]);
    setShowChatSupportIcon(true);
    if (isManual) {
      stopDesktopNotification(); // to stop sound
    }
  }

  function handleAcceptNotifiedOrder(order: any) {
    acceptOnlineOrder(order?.saleId, true, clearOrderFromNotifications);
  }

  function clearOrderFromNotifications(orderId: string) {
    stopDesktopNotification();
    clearAcceptedOrderFromNotifications(orderId);
    removeOrderFromLocalState(orderId);
    setNotificationNumber((notificationNumber) => notificationNumber - 1);
  }

  /**
   * insert order data for push notification for online orders and other orders both 
   * @param orderId 
   */
  function removeOrderFromLocalState(orderId: any) {
    let filteredNotifications = notificationsToShow?.filter(
      (notificationData: any) => {
        //if saleId is not present it is notification data else new order data
        let originalOrderData = notificationData?.event?.data?.saleVO;
        if (!originalOrderData?.saleId) originalOrderData = notificationData;
        return orderId !== originalOrderData?.saleId;
      }
    );
    setNotificationsToShow([...filteredNotifications]);
  }

  function triggerStockStatus() {
    setisMenuOpen(true);
    setOpenItemStockStatus(true);
  }

  /*
    This function is called when we receive server start success event from nw
    It updates the local server ip address in pos settings
  */
  const updateLsIpAddr = (ipAdd: any) => {
    const posSettingsValFromLS = structuredClone(posPreferences);
    console.log(
      "inside react ---- received server start event from nw----updateLsIpAddr-----posPreferences=",
      posPreferences
    );
    console.log(
      "inside react ---- received server start event from nw-----updateLsIpAddr----posSettingsValFromLS=",
      posSettingsValFromLS
    );
    console.log("inside react ---- received server start event from nw-----updateLsIpAddr----ipAdd=", ipAdd);
    if (
      !!posSettingsValFromLS?.localServer?.address &&
      posSettingsValFromLS?.localServer?.deviceIdentifier === getLocalStorage(DEVICEIDENTIFIER) &&
      posSettingsValFromLS?.localServer?.address !== ipAdd
    ) {
      set(posSettingsValFromLS, "localServer.address", ipAdd);
      console.log("inside react ---- received server start event from nw-----updateLsIpAddr----inside if=");
      if (isOffline()) {
        dispatch(getPOSSettingsDataSuccess({ response: posSettingsValFromLS }));
      } else {
        dispatch(savePosSettings({ dataToPost: posSettingsValFromLS }));
      }
    }
  };

  function handleIncomingNotifications(existingNotifications: any, newNotifications: any, typeOfNotification: string) {
    setNotificationsToShow((prev: any = []) => [newNotifications, ...prev]);
    !isMobileView() && setShowNotifications({ show: true, openForAll: false });
    isMobileView() && typeOfNotification !== OTHERS && dispatch(toggleOnlineNotificationsModal({ show: true, openForAll: false }));
    const timeoutId = setTimeout(() => {
      handleCloseNotification(AUTO_REMOVE);
    }, 10000)
    timeoutRef.current = timeoutId;
    dispatch(getAllNewOnlineOrdersSuccess([...getUpdatedNotificationData(), newNotifications]))
  }

  const serverStartEvent = (address: any) => {
    let data = {
      address: address,
      start: startCallsCount === 0,
    };
    if (isElectron()) {
      window.electronAPI!.server.start(data).then((result: any) => {
        if (result?.success) {
          setStartCallsCount((cnt) => cnt + 1);
          updateLsIpAddr(result.success.address);
          dispatch(updateMasterConnectedStatus(true));
        }
      });
    } else {
      exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.start, [data]);
    }
  };

  const serverStopEvent = () => {
    if (isElectron()) {
      window.electronAPI!.server.stop();
    } else {
      exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.stop, []);
    }
  };

  const handleToastInfo = () => {
    stopDesktopNotification();
    dispatch(updateToastInfo({ toastMessage: "", toastOpen: false, type: "", duration: 3000 }));
  };

  const handleInfoModalClose = () => {
    dispatch(updateInfoModal({}));
  };

  const handleorderLevelToastClose = () => {
    dispatch(orderLevelError({}));
  };

  const closeSyncModal = () => {
    dispatch(setSyncData(false))
    fetchCatalogCompleteData(true);
  }
  function getCashRegisterCallback() {
    switch (cashRegisterModalType) {
      case CASH_REGISTER_MODAL_TYPES.close_switch_branch:
        return handleSwitchBranch;
      case CASH_REGISTER_MODAL_TYPES.closing_balance:
        return callLogoutApi;
      case CASH_REGISTER_MODAL_TYPES.close_switch_user:
        return handleSwitchUser;
    }
  }
  function getHeaderZIndex() {
    if (isMenuOpen) return "";
    return showLsNotReachablePopup ||
      (!isStopNotificationNudge && !isNotificationAlreadyStop)
      ? "z-[1301]"
      : "";
  }

  function handleSetShowNotification(val: any) {
    setShowChatSupportIcon(!showChatSupportIcon);
    setShowNotifications(val);
  }

  function handleGlobalClick() {
    if (isChatSupportOpen) {
      setIsChatSupportOpen(false);
    }
  }

  return (
    <HomeLayoutContext.Provider value={{ removeOrderFromLocalState, setShowChatSupportIcon, showChatSupportIcon, isChatSupportOpen, setIsChatSupportOpen }}>
      <CustomLoyaltyContextProvider>
        {showBanner &&
          <Suspense fallback={<div>Loading...</div>}>
            <LicenceExpiryStatus />
          </Suspense>
        }
        <div onClick={handleGlobalClick} className="bg-grayBG h-screen">
          <div style={{ display: `${!isChatSupportOpen ? 'none' : ''}` }} className="w-[100%]">
            {
              (hasChatSupport && isChatSupportOpen) && (
                <Suspense fallback={<div>Loading...</div>}>
                  <ChatSupport />
                </Suspense>
              )
            }
          </div>
          <div className="fixed right-0 w-[30%] z-[10000]">
            {listOfNewChatSupport?.length > 0 && (
              <Suspense fallback={<div>Loading...</div>}>
                <ChatSupportNotification setListOfNewChatSupport={setListOfNewChatSupport} listOfNewChatSupport={listOfNewChatSupport} />
              </Suspense>
            )}
          </div>
          {isStopNotificationNudge && !isNotificationAlreadyStop && (
            <Suspense fallback={<div>Loading...</div>}>
              <NotificationStopNudge />
            </Suspense>
          )}
          {syncOrderData && (
            <Suspense fallback={<div>Loading...</div>}>
              <SaleSyncModal handleClose={closeSyncModal} />
            </Suspense>
          )}
          {!(isAndroid() || isMobileView()) && (
            <div className={`header-layout w-full fixed ${getHeaderZIndex()}`}>
              <Header showChatSupport={showChatSupportIcon} setShowChatSupportIcon={setShowChatSupportIcon}
                toggleNotificationsModal={setShowNotifications}
                setNotificationNumber={setNotificationNumber}
                openItemStockStatus={openItemStockStatus}
                setisMenuOpen={setisMenuOpen}
                isMenuOpen={isMenuOpen}
                unReadNotifications={unReadNotifications}
              />
            </div>
          )}
          {branchData?.isClosed &&
            [ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE, ROUTE_CONSTANTS_MAP.MY_ORDER_ROUTE, ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE].includes(
              window?.location?.pathname
            ) ? (
            <Suspense fallback={<div>Loading...</div>}>
              <OpenBranchModal />
            </Suspense>
          ) : (
            <>
              {newOrderVisited && (
                <div style={{ display: isNewOrderRoute ? '' : 'none' }}>
                  <Suspense fallback={<div>Loading...</div>}>
                    <NewOrderContainer />
                  </Suspense>
                </div>
              )}
              {!isNewOrderRoute && <Outlet />}
            </>
          )}
          {
            checkoutModalState ?
              <Suspense fallback={<div>Loading...</div>}>
                <CheckoutContainer />
              </Suspense>
              : null
          }
          {showPostSalePopup && isPostSaleCommunicationEnabled && (
            <PostSalePopup onClose={() => dispatch(paymentSuccessPopup(false))} />
          )}
          {toastInfo.isToastOpen && (
            <Toast
              isToastOpen={toastInfo.isToastOpen}
              // ${selectedItems?.length} ${selectedItems?.length > 1 ? "items" : "item"}
              message={toastInfo.toastMessage}
              type={toastInfo.toastType == "success" ? "success" : "error"}
              position={
                toastInfo.direction
                  ? toastInfo.direction
                  : { vertical: "center", horizontal: "center" }
              }
              duration={toastInfo?.duration || 3000}
              onClose={handleToastInfo}
            />
          )}
          {orderLevelErrors?.isToastOpen && (
            <Suspense fallback={<div>Loading...</div>}>
              <MultiErrorToast
                isToastOpen={orderLevelErrors.isToastOpen}
                message={orderLevelErrors.toastMessage}
                type={orderLevelErrors?.toastType || "success"}
                position={orderLevelErrors.position}
                duration={orderLevelErrors?.duration}
                onClose={handleorderLevelToastClose}
              />
            </Suspense>
          )}
          {infoModal?.isOpen && (
            <Modal
              open={infoModal?.isOpen}
              sx={{ zIndex: 100001 }}
              onClose={handleInfoModalClose}
            >
              <div className="p-10 custom-modal absolute translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] w-full flex justify-center">
                <Box sx={style}>
                  <div className="text-18 font-semibold mb-15">Warning</div>
                  <div>{infoModal.message}</div>
                  <div className="button-container mt-20 flex justify-end">
                    <Button
                      className="mr-10"
                      variant="contained"
                      onClick={handleInfoModalClose}
                    >
                      Ok
                    </Button>
                  </div>
                </Box>
              </div>
            </Modal>
          )}
          {showCashRegisterModal && featureRestrictions(CASH_REGISTER) ? (
            <Suspense fallback={<div>Loading...</div>}>
              <CashRegisterModal
                onModalClose={() => dispatch(closeCashRegisterModal())}
                closeModalManually={isTypeCloseBalance}
                modalType={cashRegisterModalType}
                onSuccessCallback={getCashRegisterCallback()}
              />
            </Suspense>
          ) : null}
          {showLsNotReachablePopup && !isMobileView() ? (
            <Suspense fallback={<div>Loading...</div>}>
              <LocalServerStatusPopup />
            </Suspense>
          ) : null}
          {!!showKeyboardShortcutsModal ? (
            <Suspense fallback={<div>Loading...</div>}>
              <DisplayKeyboardShortcuts />
            </Suspense>
          ) : null}
          {infoModalData?.isOpen &&
            <Suspense fallback={<div>Loading...</div>}>
              <BranchToggleInfoModal
                isOpen={infoModalData?.isOpen}
                openOutlets={infoModalData?.data?.openOutlets}
                type={infoModalData?.type}
              />
            </Suspense>
          }
          {showNotifications?.show || showMobileNotifications?.show ? (
            <Suspense fallback={<div>Loading...</div>}>
              <OnlineOrderNotification
                notificationsToShow={notificationsToShow}
                setShowNotifications={handleSetShowNotification}
                showNotifications={showNotifications}
                triggerStockStatus={triggerStockStatus}
                unReadNotifications={unReadNotifications}
                handleCloseNotification={handleCloseNotification}
                handleAcceptNotifiedOrder={handleAcceptNotifiedOrder}
                setOpenMobileNotification={setOpenMobileNotification}
              />
            </Suspense>
          ) : null}
          {!!openMobileNotification ? (
            <Suspense fallback={<div>Loading...</div>}>
              <NotificationsModalMB
                open={openMobileNotification}
                setOpenMobileNotification={setOpenMobileNotification}
                newOnlineOrders={newOnlineOrders}
              />
            </Suspense>
          ) : null}
          {isSaleSyncing && (
            <Suspense fallback={<div>Loading...</div>}>
              <SaleSyncModal handleClose={closeSaleSyncModal} />
            </Suspense>
          )}
          { showLaunchWhatsNewModal && (
           <WhatsNewReleaseModal
             open={showLaunchWhatsNewModal}
             showVersionSelector={false}
             onClose={() => setShowLaunchWhatsNewModal(false)}
           />
           )}
        </div>
      </CustomLoyaltyContextProvider>
    </HomeLayoutContext.Provider>
  );
};

export default HomeLayout;